{
  "tabs": {
    "chat": "Chat",
    "reminders": "Bîranîn",
    "calendar": "Salname",
    "settings": "Mîhengan"
  },
  "common": {
    "cancel": "Bişûndekirin",
    "save": "Tomar kirin",
    "confirm": "Piştrast kirin",
    "delete": "Jêbirin",
    "back": "Paş",
    "close": "Bigre",
    "edit": "Biguherîne",
    "search": "Lêgerîn",
    "all": "Hemû",
    "loading": "Bar dike...",
    "error": "Tiştek çewt bû",
    "notFound": "Nehat dîtin",
    "tryAgain": "Ji kerema xwe dîsa biceribîne",
    "retry": "Dîsa biceribîne",
    "undo": "Vegere",
    "pullToRefresh": "Ji bo nûkirinê bikêşin",
    "justNow": "niha"
  },
  "auth": {
    "welcome": "Bi xêr hatî FishMemory",
    "tagline": "Alîkarê bîranînên WhatsApp-ê te, niha di cêpkê te de.",
    "subtitle": "Alîkarê bîranînên WhatsApp-ê te, niha di cêpkê te de.",
    "phoneLabel": "Hejmara WhatsApp-ê te",
    "phoneHint": "Em koda piştrastkirinê bi WhatsAppê şandin",
    "invalidPhone": "Ji kerema xwe hejmara telefonê rast binivîse",
    "continue": "Berdewam bike",
    "enterPhone": "Hejmara WhatsApp-ê xwe binivîse",
    "phonePlaceholder": "Hejmara telefonê",
    "sendCode": "Kodê bişîne",
    "verifyTitle": "Hejmara xwe piştrast bike",
    "otpSentTo": "Koda 6 hejmarî ji bo {{phone}} bi WhatsAppê şandî",
    "enterFullCode": "Ji kerema xwe hemû 6 hejmar binivîse",
    "invalidOtp": "Kod ne rast e. Ji kerema xwe dîsa biceribîne.",
    "otpFailed": "Şandina kodê têk çû. Dîsa biceribîne.",
    "otpResent": "Kod ji nû ve hat şandin",
    "resendIn": "Di {{seconds}} s de ji nû ve bişîne",
    "resendCode": "Kod ji nû ve bişîne",
    "enterOtp": "Kodê ku ji WhatsAppê te hat şandin binivîse",
    "verify": "Piştrast bike",
    "resend": "Kod ji nû ve bişîne",
    "wrongNumber": "Hejmara şaş e?",
    "backToPhone": "Vegere telefonê",
    "editPhone": "Hejmara telefonê biguherîne",
    "error": "Çewtiya",
    "setupTitle": "Bêje em amade bikin",
    "setupSubtitle": "Tu dikarî her dem ev li Mîhengan biguherînî",
    "namePlaceholder": "Navê te",
    "letsGo": "Amadekirin qedandin",
    "skipForNow": "Niha veqetîne"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Peyamek binivîse...",
    "inputPlaceholder": "Peyamek binivîse...",
    "typing": "FishMemory tê nivîsandin...",
    "online": "Serhêl",
    "connecting": "Tê girêdan...",
    "reconnecting": "Dîsa tê girêdan...",
    "offline": "Bê serhêl",
    "empty": "Peyivînê dest pê bike",
    "emptyHint": "Bîranîn çêbike, rêjeya xwe kontrol bike, an alîkarî bixwaze.",
    "emptyAction": "Bîranînek nimûne bişîne",
    "actions": "Çalakiyên chatê",
    "keep": "Peyamên bisaz bike",
    "clearTitle": "Chatê paqij bike",
    "clearConfirm": "Hemû peyamên vê amûrê jê bibe? Ev nekin dîsa vegerîn.",
    "clear": "Chatê paqij bike",
    "optionSelected": "Hilbijartî: {{label}}",
    "sendingSelection": "Tê şandin...",
    "connectionLost": "Dîsa tê girêdan..."
  },
  "reminders": {
    "title": "Bîranînên min",
    "active": "Çalak",
    "today": "Îro",
    "thisWeek": "Ev hefte",
    "history": "Dîrok",
    "items": "tişt",
    "emptyTitle": "Hîç bîranîn tune",
    "emptySubtitle": "Ji chatê yek çêbike û li vir xuya dibe.",
    "emptyAction": "Chatê vekin",
    "filterActive": "Çalak",
    "filterToday": "Îro",
    "filterWeek": "Ev hefte",
    "filterHistory": "Dîrok",
    "emptyState": "Hîç bîranîn tune. Dest pê bike bi chatê!",
    "swipeDone": "Qedî",
    "swipeSnooze": "Bişûndekirin",
    "swipeDelete": "Jêbirin",
    "search": "Lêgerîn di bîranîn de...",
    "upcoming": "Di pêş de",
    "completed": "Qedî",
    "overdue": "Dereng",
    "tomorrow": "Sibe",
    "synced": "Hevpar kirî {{value}}",
    "swipeHint": "Ji bo çalakiyên zêde bîranînek bişûndekirin",
    "noResults": "Bîranînên ku li lêgerînê te nehatin dîtin",
    "noResultsHint": "Biceribîne peyvên din an lêgerîn paqij bike",
    "deleteAllFailed": "Jêbirina hemû bîranînên têk çû"
  },
  "calendar": {
    "title": "Salname",
    "today": "Îro",
    "tomorrow": "Sibe",
    "completed": "Qedî",
    "noEvents": "Tiştek plan nekirî",
    "noEventsSubtitle": "Rojek hilbijêre bo dîtina bîranîn û bûyerên salnameyê.",
    "googleEvent": "Salnameya Google",
    "legendActive": "Çalak",
    "legendRecurring": "Her car dîsa",
    "legendDone": "Qedî",
    "legendGoogle": "Google",
    "previousMonth": "Mehê berê",
    "nextMonth": "Mehê din",
    "previousYear": "Salê berê",
    "nextYear": "Salê din",
    "goToToday": "Biçe îro",
    "all": "Hemû",
    "active": "Çalak",
    "done": "Qedî",
    "paused": "Rawestandî"
  },
  "settings": {
    "title": "Mîhengan",
    "profile": "Profîl",
    "name": "Navê Nîşandan",
    "enterName": "Navê xwe binivîse",
    "language": "Ziman",
    "uiLanguage": "Zimanê sepana",
    "uiLanguageHelp": "Tenê ziman, navnîşanên salnameyê û rêza nîşandan li vê amûrê diguherîne.",
    "serverLanguage": "Zimanê chatê",
    "serverLanguageHelp": "Zimanê ku server ji bo bersiv û peyamên bîranînê li hesabê te tê bikar anîn diguherîne.",
    "timezone": "Demjimêr",
    "currentTimezone": "Demjimêra niha",
    "timezoneHelp": "Hemû demên bîranînê bi vî demjimêrê nîşan têne danîn.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Demjimêrê tomar bike",
    "timezoneSaved": "Demjimêr hate nûkirin",
    "detect": "Dîtin",
    "detectFailed": "Demjimêr nayê dîtin",
    "autoDetect": "Ji GPS ve bi otomatik dîtin",
    "notifications": "Agahdariyên",
    "notificationsHelp": "Bîranînên paşîn kontrol dikin agahdariyên vegerînin piştî şandina bîranînê. Destûrên agahdariyê li amûrê hîn jî di mîhengên telefonê te de têne rêvebirin.",
    "pushEnabled": "Agahdariyên push",
    "autoDoneOnFire": "Dema şandina bîranînê otomatik qedî bike",
    "autoDoneOnFireDesc": "Dema ku vebû, bîranîn heta ku tu qedî nakî çalak dimîne.",
    "googleCalendar": "Salnameya Google",
    "google": "Salnameya Google",
    "googleConnected": "Ve girêdayî",
    "googleDisconnected": "Ne girêdayî",
    "googleConnectedHelp": "Bîranînên nû dikarin bi otomatik ve di salnameya te de hevpar bîn.",
    "googleDisconnectedHelp": "Salnameya Google bi hev re girêdan bike da ku bîranîn û bûyeran li hev bigrin.",
    "googleConnectFailed": "Girêdanê bi Salnameya Google têk çû",
    "connected": "Ve girêdayî",
    "disconnected": "Ne girêdayî",
    "connect": "Bikêşîne",
    "disconnect": "Jê bibe",
    "autoSync": "Bîranînên nû bi otomatik hevpar bike",
    "autosync": "Bîranînên nû bi otomatik hevpar bike",
    "subscription": "Aboneyî",
    "trialUsed": "Ceribandin: {{used}}/{{total}} bikar anîn",
    "trialStatus": "Ceribandin amade ye",
    "activeStatus": "Aboneyî çalak",
    "expiredStatus": "Aboneyî qedî bû",
    "unsubscribedStatus": "Abone nebû",
    "about": "Derbarê",
    "version": "Wersiyon",
    "logout": "Derkeve",
    "logoutTitle": "Derkeve",
    "logoutConfirm": "Ma tu rastî dixwazî derkevin?",
    "noName": "Nav nehat danîn",
    "serverConnection": "Girêdana serverê",
    "serverUrl": "URL-ya serverê",
    "serverEdit": "Biguherîne",
    "saveReconnect": "Tomar bike û dîsa ve girêdanê bike",
    "resetDefault": "Vegere destpêkê",
    "invalidServerUrlTitle": "URL-ya serverê ne rast e",
    "invalidServerUrlMessage": "URL-ya serverê http an https-ê rast binivîse, mînak https://example.com",
    "uiLanguageChangeFailed": "Guhertina zimanê sepana têk çû. Ji kerema xwe dîsa biceribîne.",
    "serverLanguageChangeFailed": "Guhertina zimanê chatê têk çû. Ji kerema xwe dîsa biceribîne.",
    "timezoneChangeFailed": "Guhertina demjimêrê têk çû. Ji kerema xwe dîsa biceribîne.",
    "autoSyncChangeFailed": "Nûkirina hevparkirina otomatik têk çû. Ji kerema xwe dîsa biceribîne.",
    "nameChangeFailed": "Nûkirina navê nîşandan têk çû. Ji kerema xwe dîsa biceribîne.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Hûrguliyên bîranînê",
    "editTime": "Dem biguherîne",
    "rename": "Nav biguherîne",
    "snooze": "Bişûndekirin",
    "snooze15": "15 xulek bişûndekirin",
    "pause": "Rawestandîn",
    "pauseReminder": "Bîranîn rawestandîne",
    "resume": "Vegere",
    "resumeReminder": "Bîranîn vegerîne",
    "skip": "Pêşerojê veqetîne",
    "skipOccurrence": "Ev car veqetîne",
    "syncGoogle": "Bi Google hevpar bike",
    "delete": "Jêbirin",
    "deleteTitle": "Jêbirina Bîranînê",
    "deleteConfirm": "Ev bîranîn bi temamî jê bibe.",
    "deleteRecurringTitle": "Jêbirina Bîranîna Her Car Dîsa",
    "deleteRecurringMessage": "Ma tu dixwazî ev car veqetîne an hemû rêza jêbikî?",
    "deleteThisOccurrence": "Ev car veqetîne",
    "deleteEntireSeries": "Hemû rêza jêbikî",
    "done": "Qedî",
    "markDone": "Wek qedî nîşan bide",
    "undo": "Vegere",
    "undoPrompt": "Divê ji nû ve çalak be? Niha vegere.",
    "recurring": "Her car dîsa",
    "nextRun": "Dema pêşerojê",
    "oneTime": "Yek car",
    "pending": "Li benda",
    "sent": "Şandî",
    "paused": "Rawestandî",
    "active": "Çalak",
    "snoozed": "Bişûndekirî",
    "localTime": "Di demjimêra herêmî ya te de nîşan dide",
    "recurrence": "Her car dîsa",
    "created": "Afirandî",
    "tags": "Tîpan",
    "fireCount": "Hejmara şandinê",
    "actions": "Çalakî",
    "none": "Tiştek tune",
    "snoozeFailed": "Bişûndekirina bîranînê têk çû",
    "pauseFailed": "Rawestandina bîranînê têk çû",
    "resumeFailed": "Vegera bîranînê têk çû",
    "skipFailed": "Veqetandina bîranînê têk çû",
    "doneFailed": "Nîşandan wek qedî têk çû",
    "undoFailed": "Vegera rewşa bîranînê têk çû",
    "deleteFailed": "Jêbirina bîranînê têk çû",
    "rescheduleTitle": "Dîsa rêz bike?",
    "rescheduleMsg": "Ev bîranîn dereng bûye. Ma tu dixwazî dîsa rêz bikî?",
    "reschedule15": "Di 15 xulek de",
    "reschedule60": "Di 1 saat de",
    "keepOverdue": "Wek xwe bimîne"
  },
  "onboarding": {
    "slide1Title": "Bi xêr hatî FishMemory",
    "slide1Sub": "Alîkarê bîranînên kesane — bi WhatsApp ve çalak û ji bo cêpkê te çêkirî.",
    "slide2Title": "Tenê bi xwe peyivîn",
    "slide2Sub": "Bîranînên xwe wek ku tê difikirî binivîse: \"Bîranîn bike sibeh saet 3ê dê mamê bang bikim\" — em her tiştê din rêxistin.",
    "slide3Title": "Hîç tişt ne ji dest nedê",
    "slide3Sub": "Agahdariyên demkî bistîne, bi tîpan rêkxistin bike, û li ser hemû tiştên girîng bimîne.",
    "getStarted": "Dest pê bike",
    "next": "Piştî",
    "firstReminderTitle": "Yekem bîranînê xwe çêbike!",
    "firstReminderHint": "Hewce ye tiştek wek vî binivîse:",
    "firstReminderExample": "Bîranîn bike sibeh saet 9ê avê vexwim",
    "gotIt": "Fahm kir!",
    "notifRationaleTitle": "Li ser dem bimîne",
    "notifRationaleBody": "FishMemory hewce ye agahdariyên bide da ku te di demê xwe de bîranîn bike. Tenê ji bo bîranînên ku tu çêdikî agahdarî tê de.",
    "notifRationaleAllow": "Agahdariyên çalak bike",
    "notifRationaleLater": "Gava din",
    "swipeHint": "Ji bo çalakiyên zû rast bikêşîne →",
    "calendarDragHint": "Ji bo firehkirinê bikêşîne ↕"
  }
}
